import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Input, Text, VStack, Heading } from "@chakra-ui/react";
import AuthService from "./AuthService";

export default function LoginView() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (AuthService.isLocalDev()) {
      navigate("/orders", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await AuthService.login(username, password);
      navigate("/orders", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
      <Box bg="white" p={8} borderRadius="md" boxShadow="md" w="100%" maxW="400px">
        <Heading size="md" mb={6} color="#00205B">Sign in</Heading>
        <form onSubmit={handleSubmit}>
          <VStack gap={4} align="stretch">
            <Box>
              <Text fontSize="sm" fontWeight="medium" mb={1}>Username</Text>
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </Box>
            <Box>
              <Text fontSize="sm" fontWeight="medium" mb={1}>Password</Text>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Box>
            {error && (
              <Text color="red.500" fontSize="sm">{error}</Text>
            )}
            <Button
              type="submit"
              bg="#00205B"
              color="white"
              _hover={{ bg: "#001540" }}
              loading={loading}
              disabled={loading}
              mt={2}
            >
              Sign in
            </Button>
          </VStack>
        </form>
      </Box>
    </Box>
  );
}
